import { type RefObject, useEffect, useMemo } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

import { debounce } from '../helpers/functions';

type Params = {
  elementRefs: Array<RefObject<HTMLElement | null>>;
  observer: () => void;
};

const RESIZE_OBSERVE_DEBOUNCE_TIME_MS = 150;

export const useResizeObserver = ({ elementRefs, observer }: Params): void => {
  // Debounce Observer Function - In order to fix warning : ResizeObserver - loop limit exceeded
  const resizeObserver = useMemo(
    () => new ResizeObserver(debounce(RESIZE_OBSERVE_DEBOUNCE_TIME_MS)(observer)),
    [observer],
  );
  useEffect(() => {
    const elements = elementRefs.map(elementRef => elementRef.current).filter(Boolean) as HTMLElement[];
    elements.forEach(element => resizeObserver.observe(element));
    return () => resizeObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resizeObserver, ...elementRefs]);
};
